import { addChildAt } from '@ps/bridge/qc/node'
import store from '@ps/store'
import qc from 'qc'
import { findByUuid } from '@ps/bridge/qc/node/utils'
import { EventBus, Event } from '@ps/utils/event-bus'
import { getScript, IDragonBoneScript } from '@ps/bridge/qc/scripts/dragon-bone'
function resetScript(node: qc.Node, data: IDragonBoneScript) {
  const script = getScript(node)!
  Object.keys(data).forEach((key) => {
    if (key in script) {
      // @ts-ignore
      script[key] = data[key]
    }
  })
}
export type AddDragonBoneActionValue = {
  newValue: {
    node: qc.Node // 新节点
    parent: qc.Node // 新节点要插入的目标节点
    index: number // 插入位置
    realNode?: qc.Node
  }
  oldValue: {
    node: qc.Node // 新节点
    activeUuid: string // 新增节点时刻的激活节点
  }
}
export type ReplaceDragonBoneActionValue = {
  newValue: {
    node: qc.Node // 新节点
    resourceUuid: string
  }[]
  oldValue: {
    node: qc.Node // 新节点
    resourceUuid: string
    sk: IDragonBoneScript
  }[]
}

export function getAddDragonBoneAction(value: AddDragonBoneActionValue) {
  return {
    execute: async ({ newValue }: AddDragonBoneActionValue) => {
      const { node, parent, index, realNode } = newValue
      // 新增节点的时候在 recordHistory 之前已经增加节点了，所以需要判断节点树上是否有该节点
      if (!findByUuid(node.uuid)) {
        addChildAt({
          node,
          parent,
          index,
        })
      }
      await store.dispatch('workspace/game/updateActiveNode', {
        node: realNode || node,
        record: false,
      })
    },
    undo: ({ oldValue }: AddDragonBoneActionValue) => {
      const { node, activeUuid } = oldValue
      node.removeSelf()
      // 如果undo的时候记录了要激活的节点，则激活该节点
      const activeNode = findByUuid(activeUuid)
      if (activeNode) {
        store.dispatch('workspace/game/updateActiveNode', {
          node: activeNode,
          record: false,
        })
      } else {
        store.dispatch('workspace/game/clearActiveNode', {
          record: false,
        })
      }
    },
    value,
    async: true,
    methodName: 'getAddDragonBoneAction',
  }
}

export function getReplaceDragonBoneAction(
  value: ReplaceDragonBoneActionValue,
) {
  return {
    execute: async ({ newValue }: ReplaceDragonBoneActionValue) => {
      newValue.forEach(async (value: any) => {
        const { resourceUuid, node } = value
        resetScript(node, {
          playOnAwake: true,
          loop: false,
          speed: 1,
          delay: 0,
        })
        await store.dispatch('workspace/game/setImage', {
          resourceUuid: resourceUuid,
          nodeUuid: node ? node.uuid : '',
          resetImageAfterAdd: false,
          record: false,
        })
      })
      EventBus.$emit(Event.REFRESHLAYER)
    },
    undo: async ({ oldValue }: ReplaceDragonBoneActionValue) => {
      oldValue.forEach(async (value: any) => {
        const { resourceUuid, node, sk } = value
        resetScript(node, sk)
        await store.dispatch('workspace/game/setImage', {
          resourceUuid: resourceUuid,
          nodeUuid: node ? node.uuid : '',
          resetImageAfterAdd: false,
          record: false,
        })
      })
      EventBus.$emit(Event.REFRESHLAYER)
    },
    value,
    async: true,
    methodName: 'getReplaceDragonBoneAction',
  }
}
